var decoration, base;

module.exports = function (d, b) {
  if (INKIVE.C?.BOOK?.book_type == INKIVE.C?.BOOK_TYPE?.RESTRICTED_DESIGN) {
    base = b;
    decoration = d;

    var extension = {
      _parentObject: base
    };

    _.each(decoration, processDecoratorMethod, extension);
    return b.extend
      ? b.extend(extension)
      : _.extend({}, b, extension);
  }

  return b;
};

function processDecoratorMethod (func, key) {
  var isCheckMethod = key.match(/Check$/) || key.match(/CheckOnce$/);

  if (!isCheckMethod) {
    var checkMethod = decoration[key + 'Check'];
    var checkOnceMethod = decoration[key + 'CheckOnce'];

    if (checkOnceMethod) {
      if (checkOnceMethod.call(this)) this[key] = func;
    } else if (checkMethod) {
      this[key] = _.partial(decoratedMethodWrapper, checkMethod, func, base.prototype[key]);
    } else {
      this[key] = func;
    }
  }
}

function decoratedMethodWrapper (checkFunc, restrictionFunc, baseFunc) {
  var useRestrictionFallback = checkFunc.call(this);

  useRestrictionFallback && restrictionFunc.apply(this, _.rest(arguments, 3));
  useRestrictionFallback || (baseFunc && baseFunc.apply(this, _.rest(arguments, 3)));
}
